/* Memory & projects: saved memory, instructions and styles, personal context, project brain, wellbeing,
   files, projects, notebooks and drive (API: api/src/modules/memory/README.md). The privacy center
   (MEM-06) is the settings feature's screen; this one links to it. */
import { lazy } from 'react';
import { Brain } from 'lucide-react';
import { defineFeature } from '../../app/feature';

export default defineFeature({
  id: 'memory',
  title: 'Memory & projects',
  short: 'Memory',
  icon: Brain,
  group: 'You',
  route: '/memory',
  order: 10,
  rail: true,
  screen: lazy(() => import('./Screen.tsx')),
  commands: [
    { id: 'memory', title: 'Manage memory', to: '/memory', keywords: ['remember', 'forget', 'instructions', 'style', 'personal context', 'brain'] },
    { id: 'projects', title: 'Projects', to: '/memory/projects', keywords: ['workspace', 'files', 'share', 'members'] },
    { id: 'notebooks', title: 'Notebooks', to: '/memory/notebooks', keywords: ['sources', 'grounded', 'study guide', 'quiz', 'mind map'] },
    { id: 'drive', title: 'Drive', to: '/memory/drive', keywords: ['files', 'upload', 'outputs', 'trash', 'storage'] },
  ],
  capabilities: ['MEM-01', 'MEM-02', 'MEM-03', 'MEM-04', 'MEM-05', 'KNOW-01', 'KNOW-02', 'KNOW-03', 'KNOW-04', 'KNOW-05'],
});
